<template>
    <MonthPicker
        ref="dateSelector"
        v-model="accrualStartMonthYear"
        size="sm"
        data-cy="trans-accr-entry-date"
        placeholder="Startmåned og år"
        date-format="MM.yy"
    />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import {computed} from 'vue'
import MonthPicker from '@/dateUtils/MonthPicker.vue'

const line = defineModel<TransactionEntryLine>({required: true})

const accrualStartMonthYear = computed({
    get: () => {
        if (line.value.accrualStartMonth !== undefined && line.value.accrualStartYear !== undefined) {
            return {
                month: line.value.accrualStartMonth - 1, // Convert to 0-based month index start
                year: line.value.accrualStartYear
            }
        } else return undefined
    },
    set: (accrualStart) => {
        if (accrualStart) {
            line.value.accrualStartMonth = accrualStart.month + 1 // Convert to 1-based month index
            line.value.accrualStartYear = accrualStart.year
        } else {
            line.value.accrualStartMonth = undefined
            line.value.accrualStartYear = undefined
        }
    }
})
</script>

<style scoped>

</style>